import { useEffect } from 'react'
import { AppRouter } from './AppRouter'
import { Box, CssBaseline, ThemeProvider } from '@mui/material'
import { theme } from './theme'
import { Alert } from './@ui/alert/Alert'
import { MaintenanceModal } from './components/MaintenanceModal'

const App = () => {
  useEffect(() => {
    console.log(`Build time: ${__BUILD_TIME__}`)
  }, [])

  return (
    <>
      <Alert />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          onClick={() =>
            window.dataLayer?.push({
              event: 'clicked_on_buildtime',
              event_name: 'clicked_on_buildtime',
            })
          }
          sx={{
            opacity: 0.02,
            color: 'black',
            position: 'absolute',
            right: 0,
            top: 0,
            '&:hover': {
              opacity: 0.1,
            },
          }}>
          {__BUILD_TIME__}
        </Box>
        <AppRouter />
        <MaintenanceModal />
      </ThemeProvider>
    </>
  )
}

export default App
